/**
 * Version 0.110
 *
 * Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
 * Copyright 2016 - 2026.
 *
 * !Changelog
 * 
 * 2026
 * 17-07-2026
 * - [CHANGE] CTA tracking handler is now universal and bound once outside paintings setup.
 * 17-07-2026
 * - [CHANGE] CTA tracking now reads only FAQ question titles for cta_text.
 * 09-07-2026
 * - [ADDED] Paintings scroller now duplicates items for seamless infinite auto-scroll.
 * 09-07-2026
 * - [CHANGE] FAQ click flow now sets active class state before slide animations.
 * 08-02-2026
 * - [CHANGE] images.preload() is now checking if the function exists before calling it.
 * 2018
 * 	17-10-2018
 * 	- [BORN] This class is born. Hooray!
 *
 * !Usage
 *
 * 	-
 *
 * !Wishlist
 *
 * 	none
 */

var specific_interactions_firstload = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function () {

		/**
		 * Trigger: modal and popup preloader
		 */
		if (typeof images !== 'undefined' && typeof images.preload === 'function') {
			images.preload();
		}
		modal.onready();
		popup.onready();
		form.onready();
		if (pollConnection === 1) { poll_connection.onready(); }

		/**
		 * Trigger: onready classes
		 */
		specific_mobilemenu.onready();

		/**
		 * Visitor recording
		 */
		//specific_visitor_recording.onready();

		/**
		 * Trigger: onready specific classes
		 */
		// none yet

		/**
		 * FAQ
		 * FAQ
		 * FAQ
		 * FAQ
		 */
		$(document).on('click', '.js-faq-question', function () {

			var $this = $(this);
			var $answer = $this.find('.question-content');
			var is_opening = !$this.hasClass('active');

			/**
			 * Set active state before animation starts
			 */
			$('.js-faq-question').removeClass('active');
			if (is_opening) {
				$this.addClass('active');
			}

			/**
			 * Close all other answers
			 */
			$('.js-faq-question').not($this).find('.question-content').stop(true, true).slideUp();

			/**
			 * Animate selected answer based on the new state
			 */
			if (is_opening) {
				$answer.stop(true, true).slideDown();
			} else {
				$answer.stop(true, true).slideUp();
			}

		});

		/**
		* Paintings scroller: clone items once for a seamless infinite loop.
		* Paintings scroller: clone items once for a seamless infinite loop.
		* Paintings scroller: clone items once for a seamless infinite loop.
		* Paintings scroller: clone items once for a seamless infinite loop.
		*/
		$('.js-paintings-scroller').each(function () {

			var $scroller = $(this);
			var $paintings = $scroller.children('.painting');

			/**
			* Skip setup when already initialized or no paintings are available.
			*/
			if ($scroller.hasClass('is-infinite-active') || $paintings.length === 0) {
				return;
			}

			/**
			* Duplicate the original set to make the loop seamless.
			*/
			$paintings.clone()
				.attr('aria-hidden', 'true')
				.addClass('is-clone')
				.appendTo($scroller);

			/**
			* Activate CSS animation after cloning is complete.
			*/
			$scroller.addClass('is-infinite-active');

		});

		/**
		 * Button: record click tracking for buttons (universal, bind once).
		 */
		$(document)
			.off('click.ctaTrack', '.js-button-rec')
			.on('click.ctaTrack', '.js-button-rec', function (e) {

				var $button = $(this);

				/**
				 * Prevent duplicate tracking when clicking tracked links inside FAQ items.
				 */
				if ($button.hasClass('js-faq-question')) {
					var $innerTracked = $(e.target).closest('.js-button-rec');
					if ($innerTracked.length > 0 && !$innerTracked.is($button)) {
						return;
					}
				}

				var ctaLocation = $button.data('cta-location') || 'unknown';
				var ctaText = '';

				/**
				 * For FAQ tracking, only use the question title as CTA text.
				 */
				if ($button.hasClass('js-faq-question')) {
					ctaText = $.trim($button.find('.question-header h3:first').text());
				} else if ($button.find('.button-label:first').length > 0) {
					ctaText = $.trim($button.find('.button-label:first').text());
				} else {
					ctaText = $.trim($button.text());
				}

				ctaText = ctaText || 'unknown';

				/**
				 * Only when ctaLocation and ctaText are available, push to dataLayer.
				 */
				if (!ctaLocation || !ctaText) {
					return;
				}

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: 'cta_click',
					cta_location: ctaLocation,
					cta_text: ctaText
				});

			});

		/**
		 * Advertising tracking passing to iframe
		 * Advertising tracking passing to iframe
		 * Advertising tracking passing to iframe
		 * Advertising tracking passing to iframe
		 */
		const iframe = document.getElementById('reservation-iframe');

		if (iframe && window.location.search) {
			const iframeUrl = new URL(iframe.src);
			const pageParams = new URLSearchParams(window.location.search);

			pageParams.forEach(function (value, key) {
				iframeUrl.searchParams.set(key, value);
			});

			iframe.src = iframeUrl.toString();
		}

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none

}).apply(specific_interactions_firstload); 
